export default __webpack_public_path__ + "files/webinar2.pdf";